
import EyeLevelSettingsService from './EyeLevelSettingsService';

export { default } from './EyeLevelSettingsService';
export const eyeLevelSettingsService = new EyeLevelSettingsService();